import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';
import WriteArea from "./area/write";

function WordInsideWriteArea(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    is_show_close_btn: true,
    close_btn_text: "닫기",
    row_data: {},
    is_update: false,
    ...props
  };

  const [row_data, set_row_data] = useState<any>(myProps.row_data);
  const [is_update, set_is_update] = useState<boolean>(myProps.is_update);
  const user = useSelector((state: any) => state.user);

  useEffect(() => {
    get_info_by_ajax({});
  }, [user.comp_seq]);

  const get_info_by_ajax = (inData: any) => {
    let opt_obj = {
      pri_val: row_data.a_seq,
      ...inData,
    };
    if (strFunc.is_empty(opt_obj.pri_val)) {
      return false;
    }
    let form_json_data: any = {
      s_mcomp_seq: user.comp_seq,
      s_seq: opt_obj.pri_val,
      is_paging: "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/word/word_inside/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            set_row_data(response.data["data"]["info_arr"][0]);
            set_is_update(true);
          }
        } else {

        }
      });
  };

  const save_info_by_ajax = () => {
    if (row_data.a_title == "") {
      alert("제목을 입력해 주세요.");
      return;
    }

    if (!confirm("저장하시겠습니까?")) {
      return;
    }

    let form_json_data: any = {
      data_arr: [row_data],
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/word/word_inside/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          myProps.refreshData({});
          myProps.closePopup();
        } else {
          alert("저장에 실패하였습니다." + response.data["msg"]);
        }
      });
  };

  return (
    <div>
      <WriteArea
        row_data={row_data}
        set_row_data={set_row_data}
        is_update={is_update}
      ></WriteArea>

      <div className='my_flex_center mt-2'>
        <button className='btn btn-sky'
          onClick={() => { save_info_by_ajax(); }}>저장</button>
        {myProps.is_show_close_btn &&
          <button className='btn btn-dark'
            onClick={() => { myProps.closePopup(); }} >{myProps.close_btn_text}</button>
        }
      </div>
    </div>
  );
};
export default WordInsideWriteArea;